import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useTranslation } from 'react-i18next';

export default function ServicesPage() {
  const { t } = useTranslation('common');
  
  const services = [
    {
      icon: 'ri-truck-line',
      title: t('services.truckParts'),
      description: t('services.truckPartsDesc'),
      features: [
        t('services.feature1'),
        t('services.feature2'),
        t('services.feature3'),
        t('services.feature4'),
        t('services.feature5'),
        t('services.feature6')
      ]
    },
    {
      icon: 'ri-trailer-line',
      title: t('services.trailerParts'),
      description: t('services.trailerPartsDesc'),
      features: [
        t('services.feature7'),
        t('services.feature8'),
        t('services.feature9'),
        t('services.feature10'),
        t('services.feature11'),
        t('services.feature12')
      ]
    },
    {
      icon: 'ri-tools-line',
      title: t('services.support'),
      description: t('services.supportDesc'),
      features: [
        t('services.feature13'),
        t('services.feature14'),
        t('services.feature15'),
        t('services.feature16'),
        t('services.feature17'),
        t('services.feature18')
      ]
    },
    {
      icon: 'ri-time-line',
      title: t('services.delivery'),
      description: t('services.deliveryDesc'),
      features: [
        t('services.feature19'),
        t('services.feature20'),
        t('services.feature21'),
        t('services.feature22'),
        t('services.feature23'),
        t('services.feature24')
      ]
    },
    {
      icon: 'ri-shield-check-line',
      title: t('services.warranty'),
      description: t('services.warrantyDesc'),
      features: [
        t('services.feature25'),
        t('services.feature26'),
        t('services.feature27'),
        t('services.feature28'),
        t('services.feature29'),
        t('services.feature30')
      ]
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('services.customOrders'),
      description: t('services.customOrdersDesc'),
      features: [
        t('services.feature31'),
        t('services.feature32'),
        t('services.feature33'),
        t('services.feature34'),
        t('services.feature35'),
        t('services.feature36')
      ]
    }
  ];

  const brands = [
    { name: 'Mercedes-Benz', logo: 'https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/6adbe762acc69df8bfdc36ec214fe146.png' },
    { name: 'Volvo', logo: 'https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/6adbe762acc69df8bfdc36ec214fe146.png' },
    { name: 'Scania', logo: 'ri-truck-line' },
    { name: 'MAN', logo: 'https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/b1e3ccc44bb795a5deb892996c6e500b.png' },
    { name: 'DAF', logo: 'https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/a3102fb822637db18bbad174786e67eb.png' },
    { name: 'Iveco', logo: 'https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/cfc81a3fd1eb19a3293ca896a091f435.png' },
    { name: 'Renault', logo: 'https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/ca80e68792372945d98405792a3e72b2.png' }
  ];

  const process = [
    {
      step: '01',
      title: t('services.step1'),
      description: t('services.step1Desc'),
      icon: 'ri-phone-line'
    },
    {
      step: '02',
      title: t('services.step2'),
      description: t('services.step2Desc'),
      icon: 'ri-search-line'
    },
    {
      step: '03',
      title: t('services.step3'),
      description: t('services.step3Desc'),
      icon: 'ri-file-list-3-line'
    },
    {
      step: '04',
      title: t('services.step4'),
      description: t('services.step4Desc'),
      icon: 'ri-checkbox-circle-line'
    },
    {
      step: '05',
      title: t('services.delivery'),
      description: t('services.step5Desc'),
      icon: 'ri-truck-line'
    },
    {
      step: '06',
      title: t('services.step6'),
      description: t('services.step6Desc'),
      icon: 'ri-customer-service-2-line'
    }
  ];

  const stats = [
    {
      icon: 'ri-time-line',
      number: t('services.yearsExp'),
      label: t('services.yearsExpDesc')
    },
    {
      icon: 'ri-box-3-line',
      number: t('services.partsStock'),
      label: t('services.partsStockDesc')
    },
    {
      icon: 'ri-user-smile-line',
      number: t('services.satisfiedCustomers'),
      label: t('services.satisfiedCustomersDesc')
    },
    {
      icon: 'ri-customer-service-2-line',
      number: t('services.support247'),
      label: t('services.support247Desc')
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center text-white py-32"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/6a58bf0d537fcdca1960dc805f422ce9.jpg')`
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">{t('services.title')}</h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('services.whatWeOffer')}</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              {t('services.whatWeOfferDesc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                {index === 0 ? (
                  <div className="w-16 h-16 rounded-xl overflow-hidden mb-6">
                    <img 
                      src="https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/e7dfdf43c2b6c8d52535b942279272c4.png" 
                      alt="Truck"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : index === 1 ? (
                  <div className="w-16 h-16 rounded-xl overflow-hidden mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Modern%20commercial%20semi-trailer%20for%20trucks%2C%20professional%20side%20view%20of%20cargo%20trailer%20with%20clean%20design%2C%20flatbed%20or%20box%20trailer%20used%20for%20transportation%20and%20logistics%2C%20industrial%20vehicle%20equipment%20on%20simple%20neutral%20background%2C%20high-quality%20automotive%20photography%20showing%20trailer%20details%20and%20construction&width=400&height=400&seq=trailer-card-2&orientation=squarish" 
                      alt="Trailer"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : index === 2 ? (
                  <div className="w-16 h-16 rounded-xl overflow-hidden mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20automotive%20technical%20support%20specialist%20with%20headset%20providing%20customer%20service%20in%20modern%20call%20center%2C%20friendly%20expert%20consultant%20helping%20with%20truck%20parts%20inquiries%2C%20clean%20office%20environment%20with%20computer%20screens%2C%20professional%20business%20atmosphere%20showing%20excellent%20customer%20care%20and%20technical%20expertise&width=400&height=400&seq=support-card-3&orientation=squarish" 
                      alt="Technical Support"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : index === 3 ? (
                  <div className="w-16 h-16 rounded-xl overflow-hidden mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20fast%20delivery%20truck%20on%20highway%20transporting%20automotive%20spare%20parts%2C%20modern%20logistics%20vehicle%20in%20motion%2C%20efficient%20shipping%20service%20for%20truck%20and%20trailer%20components%2C%20reliable%20express%20delivery%20with%20speed%20and%20safety%2C%20commercial%20freight%20transportation%20on%20open%20road&width=400&height=400&seq=delivery-card-4&orientation=squarish" 
                      alt="Fast Delivery"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : index === 4 ? (
                  <div className="w-16 h-16 rounded-xl overflow-hidden mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20quality%20warranty%20certificate%20with%20shield%20badge%20and%20checkmark%20symbol%20for%20automotive%20spare%20parts%2C%20premium%20quality%20assurance%20guarantee%20seal%2C%20official%20warranty%20documentation%20with%20professional%20design%2C%20trust%20and%20reliability%20symbol%20for%20truck%20and%20trailer%20components%2C%20clean%20business%20document%20style&width=400&height=400&seq=warranty-card-5&orientation=squarish" 
                      alt="Quality Warranty"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : (
                  <div className="w-16 h-16 rounded-xl overflow-hidden mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20Mercedes-Benz%20commercial%20truck%20on%20the%20road%2C%20modern%20Mercedes%20heavy-duty%20truck%20with%20sleek%20silver%20and%20black%20design%2C%20high-quality%20automotive%20photography%20showing%20the%20iconic%20Mercedes%20star%20logo%20and%20premium%20build%20quality%2C%20powerful%20commercial%20vehicle%20for%20transportation%20and%20logistics%2C%20clean%20background%20highlighting%20the%20trucks%20professional%20appearance%20and%20engineering%20excellence&width=400&height=400&seq=mercedes-truck-card-6&orientation=squarish" 
                      alt="Mercedes Truck"
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                <ul className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-teal-500 text-xl mr-3 flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brands Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('services.brandsWeSupport')}</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              {t('services.brandsDesc')}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-6">
            {brands.map((brand, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-6 flex flex-col items-center justify-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                {index === 0 ? (
                  <div className="w-12 h-12 rounded-lg overflow-hidden mb-3">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20Mercedes-Benz%20commercial%20truck%20front%20view%20with%20iconic%20three-pointed%20star%20logo%2C%20modern%20heavy-duty%20Mercedes%20truck%20with%20silver%20metallic%20finish%2C%20premium%20German%20engineering%20quality%2C%20powerful%20commercial%20vehicle%20for%20logistics%20and%20transportation%2C%20clean%20studio%20photography%20highlighting%20the%20Mercedes%20brand%20excellence%20and%20sophisticated%20design&width=400&height=400&seq=mercedes-brand-logo&orientation=squarish" 
                      alt="Mercedes-Benz Truck"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : index === 1 ? (
                  <div className="w-12 h-12 rounded-lg overflow-hidden mb-3">
                    <img 
                      src="https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/6adbe762acc69df8bfdc36ec214fe146.png" 
                      alt="Volvo Truck"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : index === 2 ? (
                  <div className="w-12 h-12 rounded-lg overflow-hidden mb-3">
                    <img 
                      src="https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/71ffab7558fac7a3e389f26a524a9319.png" 
                      alt="Scania Truck"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : index === 3 ? (
                  <div className="w-12 h-12 rounded-lg overflow-hidden mb-3">
                    <img 
                      src="https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/b1e3ccc44bb795a5deb892996c6e500b.png" 
                      alt="MAN Truck"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : index === 4 ? (
                  <div className="w-12 h-12 rounded-lg overflow-hidden mb-3">
                    <img 
                      src="https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/a3102fb822637db18bbad174786e67eb.png" 
                      alt="DAF Truck"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : index === 5 ? (
                  <div className="w-12 h-12 rounded-lg overflow-hidden mb-3">
                    <img 
                      src="https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/cfc81a3fd1eb19a3293ca896a091f435.png" 
                      alt="Iveco Truck"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : index === 6 ? (
                  <div className="w-12 h-12 rounded-lg overflow-hidden mb-3">
                    <img 
                      src="https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/ca80e68792372945d98405792a3e72b2.png" 
                      alt="Renault Truck"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : (
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-3">
                    <i className={`${brand.icon} text-2xl text-teal-600`}></i>
                  </div>
                )}
                <span className="text-gray-900 font-semibold text-center">{brand.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('services.howItWorks')}</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              {t('services.howItWorksDesc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {process.map((item, index) => (
              <div key={index} className="relative">
                <div className="bg-gray-50 rounded-2xl p-8 h-full hover:shadow-lg transition-all duration-300">
                  <div className="flex items-start mb-6">
                    <div className="w-14 h-14 bg-teal-500 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                      <i className={`${item.icon} text-2xl text-white`}></i>
                    </div>
                    <div className="text-5xl font-bold text-teal-100">{item.step}</div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gradient-to-br from-teal-500 to-cyan-600 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">{t('services.whyChoose')}</h2>
            <p className="text-xl text-teal-50 max-w-2xl mx-auto">
              {t('services.whyChooseDesc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-medal-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-3">{t('services.yearsExp')}</h3>
              <p className="text-teal-50">{t('services.yearsExpDesc')}</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-box-3-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-3">{t('services.partsStock')}</h3>
              <p className="text-teal-50">{t('services.partsStockDesc')}</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-user-heart-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-3">{t('services.satisfiedCustomers')}</h3>
              <p className="text-teal-50">{t('services.satisfiedCustomersDesc')}</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-24-hours-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-3">{t('services.support247')}</h3>
              <p className="text-teal-50">{t('services.support247Desc')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">{t('services.needParts')}</h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
            {t('services.needPartsDesc')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/contact"
              className="bg-teal-500 hover:bg-teal-600 text-white font-semibold px-8 py-4 rounded-lg transition-colors inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-xl mr-2"></i>
              {t('services.contactUs')}
            </a>
            <a 
              href="tel:+99365049474"
              className="bg-white hover:bg-gray-100 text-gray-900 font-semibold px-8 py-4 rounded-lg transition-colors inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl mr-2"></i>
              {t('services.call')}
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
